import { url } from "../Constant/TextConstant.js";
import { apiFetch } from "../utils/apiClient.js";

export const sendFCMNotification = async ({
  Tokens,
  Title,
  Body,
  ScreenRoute,
}) => {
  try {
    const payload = {
      Tokens, // list of tokens
      Title, // notification title
      Body, // notification body
      ScreenRoute, // optional Flutter screen route
    };

    const response = await apiFetch(`${url.baseAPIUrl}/api/send-notification`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
    } else {
    }
  } catch (error) {
  }
};
export const fetchUniqueIds = async (mobileNumber) => {
  const apiUrl = `${url.baseAPIUrl}/api/LoginMaster/GetUniqueIdByMobile?mobile=${mobileNumber}`;

  try {
    const response = await apiFetch(apiUrl);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (
      Array.isArray(data) &&
      data.length > 0 &&
      typeof data[0] === "object" &&
      data[0].UniqueId
    ) {
      const uniqueIdString = data[0].UniqueId;

      if (typeof uniqueIdString === "string" && uniqueIdString.length > 0) {
        const uniqueIds = uniqueIdString.split(",");
        return uniqueIds;
      }
    }

    throw new Error("Invalid UniqueId response format");
  } catch (error) {
    return null;
  }
};
